import { HlmSkeleton } from './lib/hlm-skeleton'

export * from './lib/hlm-skeleton'

export const HlmSkeletonImports = [HlmSkeleton] as const
